



import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { CookieService } from '@/services/cookie'
import GameProcessor from '@/services/game/processor'
import { UserService } from '@ajax/modules/services/user'
import { PluginMixin } from '@spa/mixins/plugin'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class Game extends Mixins<PluginMixin>(PluginMixin) {

  /**
   * FIXME:
   * 非ブランド配下の場合、brandEnglishNameは空文字 `''` になるが、
   * これは明示的ではないので、nullableにするまたはOptionにするなど変更したい
   */
  @Prop({ default: '' })
  brandEnglishName: string

  @Prop({ required: true })
  campaignId: string

  async created() {

    if (!CookieService.isLogined()) {
      const userService = new UserService()
      await userService.registerProvisional()
    }

    await this.loadContextForThirdPartyTool()

    const gameProcessor: GameProcessor = GameProcessor.build(
      this.brandEnglishName,
      this.campaignId,
      this.gameOrganizer
    )

    gameProcessor.execute()
  }

  get gameOrganizer(): string {

    const behavior = BehaviorConfig.createFromBrand(this.brandEnglishName)

    return behavior.brandName || behavior.groupId
  }

  private async loadContextForThirdPartyTool(): Promise<void> {
    await this.loadCart()
  }

  private async loadCart(): Promise<void> {
    await this.$store.dispatch('cart/load')
  }
}
